module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Check-f4d71936cdd65b750082c44a512edac2.svg";